export default __webpack_public_path__ + "static/community_5-f08a58167db5be2a872477404ceba11b.jpg";